// extracted by mini-css-extract-plugin
export default {"error":"error_error__VydwU","footnote":"error_footnote__AM3i3"};